import { axiosInstanceWithToken } from 'utils/axios';

export const fetchConfigTotals = async () => axiosInstanceWithToken().get('configuration-requests/totals');
